import axios from "axios";
import moment from "moment-timezone";
import { useEffect } from "react";

// record view event after staying 5 seconds on a content page
export function useRecordContentWatchEvent(contentId) {
  useEffect(() => {
    const timeoutId = setTimeout(() => recordWatchEvent(contentId), 5000);
    return () => clearTimeout(timeoutId);
    // content may change while staying on the same page
  }, [contentId]);
}

export async function fetchLastWeekAllViewCounts() {
  const { data } = await axios.get("/api/view-data/week");
  return data;
}

export async function fetchLastYearAllViewCounts() {
  const { data } = await axios.get("/api/view-data/year");
  return data;
}

export async function fetchLifetimeAllViewCounts() {
  const { data } = await axios.get("/api/view-data/lifetime");
  return data;
}

export async function fetchLastWeekViewCountByContent() {
  const lastWeek = moment().subtract(7, "days").format("YYYY/MM/DD"); // format as date to remove the time
  const { data } = await axios.get("/api/view-data/count-by-content?afterDate=" + lastWeek);
  return data;
}

export async function fetchLastYearViewCountByContent() {
  const lastYear = moment().subtract(1, "year").format("YYYY/MM") + "/01";
  const { data } = await axios.get("/api/view-data/count-by-content?afterDate=" + lastYear);
  return data;
}

export async function fetchLifetimeViewCountByContent() {
  const { data } = await axios.get("/api/view-data/count-by-content");
  return data;
}

export async function fetchLastWeekUserViewsCount() {
  const lastWeek = moment().subtract(7, "days").format("YYYY/MM/DD");
  const { data } = await axios.get("/api/view-data/count-by-user?afterDate=" + lastWeek);
  return data;
}

export async function fetchLastYearUserViewsCount() {
  const lastYear = moment().subtract(1, "year").format("YYYY/MM") + "/01";
  const { data } = await axios.get("/api/view-data/count-by-user?afterDate=" + lastYear);
  return data;
}

export async function fetchLifetimeUserViewsCount() {
  const { data } = await axios.get("/api/view-data/count-by-user");
  return data;
}

export async function fetchUserFollowerCount() {
  const { data } = await axios.get("/api/user/follower-count");
  return data;
}

function recordWatchEvent(contentId) {
  try {
    axios.post("/api/view-data", { ContentId: contentId });
  } catch (err) {
    console.error("Failed to record analytics watch event", err);
  }
}

export async function fetchMonthlyActiveUsersCount() {
  const { data } = await axios.get("/api/view-data/monthly-active-users");
  return data;
}
